import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CRM_COLORS } from '../../../theme/crmColors';

const useStyles = makeStyles({
    panel: {
        boxShadow: 'none',
        margin: 0,
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
        },
    },
    summary: {
        minHeight: 44,
        '&.Mui-expanded': {
            minHeight: 44,
        },
    },
    summaryContent: {
        margin: '8px 0',
        '&.Mui-expanded': {
            margin: '8px 0',
        },
    },
    // Título de sección alineado con los headers de las listas/tablas de la app.
    title: {
        fontSize: '0.875rem',
        fontWeight: 600,
        color: CRM_COLORS.secondary,
    },
    icon: {
        color: CRM_COLORS.text.secondary,
        display: 'flex',
        alignItems: 'center',
    },
});

export interface CollapsePanelProps {
    icon?: React.ReactNode;
    title: React.ReactNode;
    children: React.ReactNode;
    detailsStyle?: React.CSSProperties;
}

const CollapsePanel: React.FC<CollapsePanelProps> = ({ icon, title, children, detailsStyle }) => {
    const classes = useStyles();

    return (
        <Accordion square elevation={0} className={classes.panel}>
            <AccordionSummary
                classes={{ root: classes.summary, content: classes.summaryContent }}
                expandIcon={<ExpandMoreIcon />}
            >
                <Box display='flex' alignItems='center'>
                    {icon ? (
                        <Box mr={1} className={classes.icon}>
                            {icon}
                        </Box>
                    ) : null}
                    <Typography className={classes.title}>{title}</Typography>
                </Box>
            </AccordionSummary>

            <AccordionDetails style={detailsStyle}>{children}</AccordionDetails>
        </Accordion>
    );
};

export default CollapsePanel;
